export default __webpack_public_path__ + "static/media/high_occupancy.9b643de8.png";